<template>
  <v-container class="my-2" tag="section"
    ><v-tooltip right>
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          color="primary"
          fixed
          bottom
          left
          v-on="on"
          @click="$router.push(`/`)"
        >
          <v-icon>mdi-puzzle</v-icon>
        </v-btn>
      </template>
      <span>{{ $t("ticket.modulesbtn") }}</span>
    </v-tooltip>
    <v-card class="my-12">
      <v-btn to="/new/ticket" top absolute right color="primary" fab>
        <v-icon>mdi-plus</v-icon>
      </v-btn>
      <v-card-title>Tickets </v-card-title>
      <v-card-subtitle
        ><v-chip
          label
          small
          v-for="(status, index) in statusQuantity"
          :key="index"
          :color="status.customStatusId.color"
          class="mr-1 black--text"
        >
          {{ status.customStatusId.name }}: {{ status.ticket }}
        </v-chip></v-card-subtitle
      >
      <v-row>
        <v-col cols="12" v-for="(item, index) in tickets" :key="index">
          <v-card
            class="my-0 mx-2"
            dark
            color="secondary"
            @click="goToTicket(item.id)"
          >
            <v-toolbar dense color="transparent" flat>
              <v-toolbar-title>
                <v-chip label color="primary">{{ getLabel(item) }}</v-chip>
              </v-toolbar-title>
              <v-spacer></v-spacer
              ><v-chip
                class="black--text"
                :color="getStatus(item.customStatusId).color"
                >{{ getStatus(item.customStatusId).name }}</v-chip
              >
            </v-toolbar>
            <v-card-title class="pt-0 mb-2">
              {{ item.title }}
            </v-card-title>
            <v-card-subtitle
              >Published on
              {{ item.createdDate | formatWithIntl }}</v-card-subtitle
            >
          </v-card></v-col
        >
      </v-row>
    </v-card>
  </v-container>
</template>
<script>
import _ from "lodash";
import { sdIssuesWorkflow, foldersId } from "../../utils/wrikeHelper";
import { mapState, mapGetters } from "vuex";
export default {
  name: "Tickets",
  components: {},
  data() {
    return {
      ticketsFromWrike: []
    };
  },
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square"
    });
    try {
      await this.$store.dispatch("tickets/bindTickets");
    } catch (error) {
      console.error(error);
    }
    loading.close();
  },
  computed: {
    statusQuantity() {
      const { getStatus } = this;
      const result = _.chain(this.tickets)
        .countBy("customStatusId")
        .map((value, key) => ({
          customStatusId: getStatus(key),
          ticket: value
        }))
        .value();
      return result;
    },
    ...mapState("tickets", ["tickets"]),
    ...mapGetters("equipments", ["equipmentsList"]),
    availableSteps() {
      const steps = [0];
      if (this.subject !== "" && this.content !== "") steps.push(1);
      return steps;
    },
    title() {
      return `[${this.ticket.equipment}] ${this.ticket.title}`;
    }
  },
  methods: {
    goToTicket(id) {
      this.$router.push({ name: "TicketProfile", params: { id: id } });
    },
    getLabel(item) {
      const label = [...item.parentIds];
      const checkIncludes = folder => label.includes(folder);
      switch (true) {
        case checkIncludes(foldersId.issues): // Issue Id Folder
          return this.$t("ticket.issues");
        case checkIncludes("IEADCDYKI4QZOUIM"): // Hardware Id Folder
          return this.$t("ticket.mechanicalSupport");
        case checkIncludes(foldersId.suggestions): // Suggestion id folder
          return this.$t("ticket.suggestions");
        default:
          return this.$t("ticket.issues");
      }
    },
    getStatus(status) {
      switch (status) {
        case sdIssuesWorkflow.new:
          return { name: "New", color: "blue" };
        case sdIssuesWorkflow.inProgress:
          return { name: "In Progress", color: "cyan" };
        case sdIssuesWorkflow.waitingOnCustomerFeedback:
          return { name: "Waiting On Customer FeedBack", color: "yellow" };
        case sdIssuesWorkflow.resolved:
          return { name: "Resolved", color: "lime" };
        case sdIssuesWorkflow.duplicated:
          return { name: "Duplicated", color: "indigo lighten-4" };
        case sdIssuesWorkflow.cancelled:
          return { name: "Cancelled", color: "grey lighten-2" };
        default:
          return { name: "Otro", color: "grey lighten-2" };
      }
    },
    next(valid) {
      if (!valid) return;
      this.submit();
    }
  }
};
</script>
